import { ICalendarDate } from '../types';

export function formatCalendarDate(calendarDate: ICalendarDate): Date {
  const { day, month, year } = calendarDate;

  return new Date(year, month - 1, day);
}
